/** @format */

import { useContext, useEffect, useState } from 'react';

import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import ModalCustom from '../../Shared/Components/ModalCustom';
import Pagination from '../../Shared/Components/Pagination';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { useRole } from '../../Shared/hooks/CustomHooks';
import useQuery from '../../Shared/queryString';
import { getStoredAuthToken } from '../../Shared/utils/authToken';
import { countOfRecourd } from '../../Shared/utils/helper';
import Master from '../Layouts/Master';

const TeamEventRegister = () => {
  const { can, canBoard } = useRole();
  const province_id = useQuery.getParam('province_id');
  const genderQueryString = useQuery.getParam('gender');
  const eventContext = useContext(EventContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const issue_tracking = useQuery.getParam('issue_tracking');
  const team_name = useQuery.getParam('team_name');
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [formRemoveId, setFormRemoveId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [issueTracking, setIssueTracking] = useState(
    issue_tracking == null ? '' : issue_tracking,
  );
  const [teamName, setTeamName] = useState(team_name != null ? team_name : '');
  const [provinceId, setProvinceId] = useState(
    province_id != null ? province_id : '',
  );
  const [gender, setGender] = useState(
    genderQueryString != null ? genderQueryString : '',
  );
  const [countExportExcel, setCountExportExcel] = useState({
    start: 0,
    end: 500,
  });
  const [excelLoading, setExcelLoading] = useState(false);

  useEffect(() => {
    getTeam();
  }, [search, id]);

  const getTeam = async () => {
    setLoading(true);
    await useApi.get(
      `/event/${id}/team/register${search}`,
      {},
      (res) => {
        eventContext.teams = res.data;
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
    await useApi.get(
      `/province`,
      {},
      (res) => {
        eventContext.provinces = res.data.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  const removeForm = async (teamId) => {
    setRemoveLoading(true);

    await useApi.delete(
      `/team/${teamId}?event_id=${id}`,
      {},
      (res) => {
        success('تیم مورد نظر با موفقیت حذف شد');
        setRemoveLoading(false);
        setModalIsOpen(false);
        getTeam();
      },
      (err) => {
        setRemoveLoading(false);
        setLoading(false);
        error('حذف به علت خطا انجام نشد');
      },
    );
  };

  const educations = (key) => {
    let educations = [
      { key: 1, value: 'بی سواد' },
      { key: 2, value: 'ابتدایی' },
      { key: 3, value: 'دیپلم' },
      { key: 4, value: 'کاردانی' },
      { key: 5, value: 'کارشناسی' },
      { key: 6, value: 'کارشناسی ارشد' },
      { key: 7, value: 'دکترا' },
      { key: 8, value: 'پسا دکترا' },
    ];

    return educations.find((e) => e.id === key);
  };
  const exportExcel = async () => {
    setExcelLoading(true);
    await useApi.get(
      `/team/${id}/report?token=${getStoredAuthToken()}${
        province_id != null ? '&province_id=' + province_id : ''
      }${genderQueryString != null ? '&gender=' + genderQueryString : ''}`,
      {},

      (res) => {
        setExcelLoading(false);
        navigate('/panel/excel');
        return success('گزارش با موفقیت در صف خروجی قرار گرفت');
      },
      (err) => {
        setExcelLoading(false);
        if (err.status == 429) {
          return error(
            'گزارش اکسل به دلیل شلوغی سرور و گزارش های اکسل در حال پردازش در حال حاضر امکان پذیر نیست لطفا در صورت امکان گزارش گیری خود را به زمان خلوتی سرور موکول کنید.',
          );
        } else {
          error('هنگام ارسال برای صف خروجی مشکلی رخ داده است');
        }
      },
    );
  };
  const searchByIssueTracking = () => {
    // if (issueTracking.length === 0) {
    // 	error('لطفا کد پیگیری را وارد نمایید.');
    // 	return;
    // }
    let searchFields = '?';
    searchFields +=
      issueTracking?.length > 0 ? '&issue_tracking=' + issueTracking : '';
    searchFields += teamName?.length > 0 ? '&team_name=' + teamName : '';
    searchFields +=
      gender?.length > 0 && gender != null ? '&gender=' + gender : '';
    searchFields += provinceId?.length > 0 ? '&province_id=' + provinceId : '';
    // let issue =
    // 	issueTracking.length > 0 ? `?issue_tracking=${issueTracking}` : '';
    return navigate(`/panel/event/${id}/team${searchFields}`);
  };

  const searchByProvince = () => {
    if (provinceId == 'undefined') {
      return error('لطفا ابتدا استان را انتخاب نمایید.');
    }

    return navigate(`/panel/event/${id}/team?province_id=${provinceId}`);
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-column alert alert-danger my-4 f-15 font-weight-bold'>
        <span className='f-16 text-danger mb-2'>مهم لطفا مطالعه کنید :‌</span>
        قابل توجه استان ها : در صورت نیاز به گزارش اکسل استان خود تنها یک بار
        اقدام به درخواست گزارش اکسل نمایید و منتظر ایجاد گزارش بمانید و از کلیک
        کردن مجدد بر روی گزارش اکسل خودداری کنید.
      </div>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2 mt-3'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست تیم های ثبت نام شده
          </h1>
        </div>
        <span className='f-16 text-secondary mt-3'>
          تعداد تیم های ثبت نامی{' '}
          {eventContext.teams?.meta?.pagination?.total ?? 0} تیم
        </span>

        <div className='d-flex flex-row align-items-center'>
          {can('Super Admin') || can('Dyaco Admin') || canBoard() ? (
            <>
              {/* <div className='form-group d-flex flex-row align-items-center mx-2 mt-3'>
                <label className='f-14 text-right mx-2 mt-1'>از</label>
                <input
                  type='number'
                  onChange={(e) =>
                    setCountExportExcel({
                      ...countExportExcel,
                      start: e.target.value,
                    })
                  }
                  className='form-control'
                  value={countExportExcel.start}
                />
              </div>
              <div className='form-group d-flex flex-row align-items-center mx-2 mt-3'>
                <label className='f-14 text-right mx-2 mt-1'>تا</label>
                <input
                  type='number'
                  onChange={(e) =>
                    setTeamName(
                      setCountExportExcel({
                        ...countExportExcel,
                        end: e.target.value,
                      }),
                    )
                  }
                  className='form-control'
                  value={countExportExcel.end}
                />
              </div> */}

              {excelLoading ? (
                <button className='d-flex flex-row btn btn-outline-info'>
                  <i className='fas fa-file-excel f-16 mx-2'></i>
                  <div
                    className='spinner-border spinner-border-sm mb-1'
                    role='status'
                  ></div>
                </button>
              ) : (
                <button
                  onClick={exportExcel}
                  className='d-flex flex-row btn btn-outline-info'
                >
                  <i className='fas fa-file-excel f-16 mx-2'></i>
                  <span className='f-13'>گزارش اکسل </span>
                </button>
              )}
            </>
          ) : null}
        </div>
      </div>
      <div className='d-flex flex-row justify-content-between w-100 my-1'>
        <div className='d-flex flex-row'>
          <div className='form-group w-50'>
            <label className='f-14 text-right'>کد پیگیری</label>
            <input
              type='text'
              onChange={(e) => setIssueTracking(e.target.value)}
              className='form-control'
            />
          </div>
          <div className='form-group w-50 mx-2'>
            <label className='f-14 text-right'>نام تیم</label>
            <input
              type='text'
              onChange={(e) => setTeamName(e.target.value)}
              className='form-control'
              value={teamName}
            />
          </div>
          <div className='form-group w-50 mx-2'>
            <label className='f-14 text-right'>جنسیت</label>
            <select
              defaultValue={gender}
              className='form-control'
              onChange={(e) => setGender(e.target.value)}
            >
              <option selected={true}>انتخاب جنسیت</option>
              <option value='0'>هردو</option>
              <option value='1'>مرد</option>
              <option value='2'>زن</option>
            </select>
          </div>
          <div className='from-group w-50 mx-2'>
            <label>استان</label>
            <select
              defaultValue={provinceId}
              onChange={(e) => setProvinceId(e.target.value)}
              className='form-control'
            >
              <option value='undefined'>انتخاب کنید</option>
              {eventContext.provinces.map((item) => (
                <option value={item.id}>{item.name}</option>
              ))}
            </select>
          </div>
          <div className='form-group mt-2'>
            <button
              onClick={searchByIssueTracking}
              className='btn bg-purple f-12 mt-4 mx-2 text-dark-mode'
            >
              جستجو
            </button>
          </div>
        </div>
        {/*<div className='d-flex flex-row'>
					<div className='from-group'>
						<label>فیلتر بر اساس استان</label>
						<select
							onChange={(e) => setProvinceId(e.target.value)}
							className='form-control'>
							<option value='undefined'>انتخاب کنید</option>
							{eventContext.provinces.map((item) => (
								<option value={item.id}>{item.name}</option>
							))}
						</select>
					</div>
					<div className='form-group mt-1'>
						<button
							onClick={searchByProvince}
							className='btn bg-purple f-12 mt-4 mx-2 text-dark-mode'>
							جستجو
						</button>
					</div>
							</div>*/}
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.teams?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>نام سرپرست</th>
                <th>{id == 11 ? 'نام سازمان' : 'نام باشگاه'}</th>
                <th>{id == 11 ? 'شماره تماس' : 'تلفن باشگاه'}</th>
                <th>استان</th>
                <th>شهرستان</th>
                <th>آدرس باشگاه</th>
                <th>نام سرپرست</th>
                <th>تلفن سرپرست</th>
                <th>عکس سرپرست</th>
                <th>عکس تیمی</th>
                <th>کاربران ثبت نام شده</th>
                <th>حذف</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.teams?.data?.map((item, index) => (
                <tr key={item.id}>
                  <th>
                    {countOfRecourd(
                      index,
                      eventContext.teams?.meta?.pagination?.per_page,
                      eventContext.teams?.meta?.pagination?.current_page,
                    )}
                  </th>
                  <td>
                    {item?.supervisor?.first_name ?? '-'}{' '}
                    {item?.supervisor?.last_name ?? '-'}
                  </td>
                  <td>{item?.club_name ?? '-'}</td>
                  <td>{item?.club_phone ?? '-'}</td>
                  <td>{item?.province?.name ?? '-'}</td>
                  <td>{item?.city ?? '-'}</td>
                  <td>{item?.club_address ?? '-'}</td>
                  <td>{item?.supervisor_name ?? '' ?? '-'}</td>
                  <td>{item?.supervisor_phone ?? '-'}</td>
                  <td>
                    {item?.supervisor_img !== null ? (
                      <img
                        src={item?.supervisor_img}
                        className='w-100'
                        alt={item?.club_name}
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    {item?.team_picture !== null ? (
                      <img
                        src={item?.team_picture}
                        className='w-100 img-thumbnail'
                        style={{ width: '60px', height: '60px' }}
                        alt={item?.club_name}
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    <Link
                      to={`/panel/event/register/${item.id}?team=true&eventId=${id}`}
                      target='_blank'
                      className='btn btn-info btn-sm d-flex flex-row justify-content-center p-2'
                    >
                      <i className='fad fa-eye text-dark-mode f-15'></i>
                    </Link>
                  </td>
                  <td>
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        setFormRemoveId(item.id);
                        setModalIsOpen(true);
                      }}
                      to='#'
                      target='_blank'
                      className='d-flex flex-row justify-content-center p-2'
                    >
                      حذف
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <span className='f-13 font-weight-bold text-secondary'>
              کاربری ثبت نام نکرده است
            </span>
          </div>
        )}
      </div>
      <Pagination
        totalPage={eventContext.teams?.meta?.pagination?.total_pages}
        basePath={`/panel/event/${id}/team`}
        search={search}
      />
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>آیا از حذف تیم مطمئنید‌؟</span>
        </div>
        <div className='d-flex flex-row my-3'>
          <i className='fas fa-exclamation-triangle f-20 text-white'></i>
          <span className='f-14 mx-2 align-self-baseline'>
            لطفا دقت فرمایید پس از حذف امکان بازیابی اطلاعات وجود ندارد.
          </span>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
          <button
            onClick={() => removeForm(formRemoveId)}
            className='btn btn-success w-48 f-13'
          >
            {removeLoading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'بله'
            )}
          </button>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default TeamEventRegister;
